import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {NotificationService} from '../../../../services/notification.service';
import {AppState} from '../../../reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs/operators';

import * as fromActions from './sample-form.actions';
import * as fromGraphql from './sample-form.graphql';

@Injectable()
export class SampleFormEffects {

  createSampleForm = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.createSampleForm), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.CREATE_SAMPLE_FORM,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while saving record'),
            map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertSampleForm({
                      sampleForm: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Created Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  updateSampleForm$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.editSampleForm), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.UPDATE_SAMPLE_FORM,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while updating record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertSampleForm({
                      sampleForm: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Updated Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  deleteSampleForm$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.removeSampleForm), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.DELETE_SAMPLE_FORM,
            variables: {
              sampleFormUniqueId: action?.sampleFormUniqueId,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while deleting record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.deleteSampleForm({ id: action.id })
                  );
                  return this.notificationService.successMessage('Deleted Successfully');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  getSampleForms$ = createEffect(
    () => {

      return this.actions$.pipe(ofType(fromActions.getSampleForms), switchMap((action) => {
        return this.apollo
          .query({
            query: fromGraphql.GET_ALL_SAMPLE_FORMS,
            fetchPolicy: 'network-only',
            variables: {
              filtering: action?.formUniqueId
            }
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while fetching form'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                result?.response?.status
                  ? this.store.dispatch(
                    fromActions.loadSampleForms({
                      sampleForms: result?.data,
                    })
                  )
                  : [];
              }
            })
          );
      })
      )
    },
    { dispatch: false }
  );

  // CITIZEN
  citizenGetServiceSampleForm$ = createEffect(
    () => {

      return this.actions$.pipe(ofType(fromActions.citizenGetServiceSampleForm), switchMap((action) => {
        return this.apollo
          .query({
            query: fromGraphql.CITIZEN_GET_SERVICE_SAMPLE_FORM,
            fetchPolicy: 'network-only',
            variables: {
              formUniqueId: action?.formUniqueId
            }
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while fetching form'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                result?.response?.status
                  ? this.store.dispatch(
                    fromActions.loadSampleForms({
                      sampleForms: result?.data,
                    })
                  )
                  : [];
              }
            })
          );
      })
      )
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) { }
}
